import { render, staticRenderFns } from "./image.vue?vue&type=template&id=50397314&scoped=true&"
import script from "./image.vue?vue&type=script&lang=ts&"
export * from "./image.vue?vue&type=script&lang=ts&"
import style0 from "./image.vue?vue&type=style&index=0&id=50397314&lang=scss&scoped=true&"
import style1 from "./image.vue?vue&type=style&index=1&id=50397314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50397314",
  null
  
)

export default component.exports